import { createAction, props } from '@ngrx/store';
import {
  AssistantMessage,
  AssistantApiResponse,
  Conversation,
  ConversationListItem,
  PendingWrite,
} from '../../shared/models/assistant.model';

// Query Actions
export const sendQuery = createAction(
  '[Assistant] Send Query',
  props<{ query: string; provider?: string; model?: string; conversationId?: string; autoCreateConversation?: boolean }>()
);

export const receiveResponse = createAction(
  '[Assistant] Receive Response',
  props<{ response: AssistantApiResponse }>()
);

export const queryFailed = createAction(
  '[Assistant] Query Failed',
  props<{ error: string }>()
);

// Conversation Management Actions
export const loadConversations = createAction(
  '[Assistant] Load Conversations',
  props<{ matterId?: string; clientId?: string; includeArchived?: boolean }>()
);

export const loadConversationsSuccess = createAction(
  '[Assistant] Load Conversations Success',
  props<{ conversations: ConversationListItem[] }>()
);

export const loadConversationsFailure = createAction(
  '[Assistant] Load Conversations Failure',
  props<{ error: string }>()
);

export const selectConversation = createAction(
  '[Assistant] Select Conversation',
  props<{ conversationId: string }>()
);

export const loadConversationMessages = createAction(
  '[Assistant] Load Conversation Messages',
  props<{ conversationId: string }>()
);

export const loadConversationMessagesSuccess = createAction(
  '[Assistant] Load Conversation Messages Success',
  props<{ conversation: Conversation }>()
);

export const loadConversationMessagesFailure = createAction(
  '[Assistant] Load Conversation Messages Failure',
  props<{ error: string }>()
);

export const newConversation = createAction(
  '[Assistant] New Conversation',
  props<{ matterId?: string; clientId?: string; title?: string }>()
);

export const newConversationSuccess = createAction(
  '[Assistant] New Conversation Success',
  props<{ conversation: Conversation }>()
);

export const newConversationFailure = createAction(
  '[Assistant] New Conversation Failure',
  props<{ error: string }>()
);

export const updateConversation = createAction(
  '[Assistant] Update Conversation',
  props<{ conversationId: string; updates: { title?: string; isArchived?: boolean; matterId?: string; clientId?: string } }>()
);

export const updateConversationSuccess = createAction(
  '[Assistant] Update Conversation Success',
  props<{ conversation: Conversation }>()
);

export const updateConversationFailure = createAction(
  '[Assistant] Update Conversation Failure',
  props<{ error: string }>()
);

export const archiveConversation = createAction(
  '[Assistant] Archive Conversation',
  props<{ conversationId: string }>()
);

export const archiveConversationSuccess = createAction(
  '[Assistant] Archive Conversation Success',
  props<{ conversationId: string }>()
);

export const deleteConversation = createAction(
  '[Assistant] Delete Conversation',
  props<{ conversationId: string }>()
);

export const deleteConversationSuccess = createAction(
  '[Assistant] Delete Conversation Success',
  props<{ conversationId: string }>()
);

export const deleteConversationFailure = createAction(
  '[Assistant] Delete Conversation Failure',
  props<{ error: string }>()
);

// Admin write confirmation actions
export const confirmPendingWrite = createAction(
  '[Assistant] Confirm Pending Write',
  props<{ pendingWrite: PendingWrite; sessionId: string }>()
);

export const cancelPendingWrite = createAction(
  '[Assistant] Cancel Pending Write',
  props<{ pendingWrite: PendingWrite; sessionId: string }>()
);

export const clearMessages = createAction('[Assistant] Clear Messages');

export const clearError = createAction('[Assistant] Clear Error');

export const hydrateMessages = createAction(
  '[Assistant] Hydrate Messages',
  props<{ messages: AssistantMessage[] }>()
);
